import { endpoint,mappable } from '../decorators';
import { BaseViewModel } from './base-view-model';
import { CorrespondenceCategoryViewModel } from './correspondence-category-view-model';
import { RequestorCorrespondenceViewModel } from './requestor-correspondence-view-model';
import { RequestorViewModel } from './requestor-view-model';

@endpoint('Correspondence')
export class CorrespondenceViewModel extends BaseViewModel {
  /** The type of the correspondence (incoming, outgoing, etc) */
  public Type = '';

  /** This could be an email correspondence subject line, or intake staff's own title. */
  public Title = '';

  /** Could be the body of the email correspondence, or intake staff's summary. */
  public Summary = '';

  /** A short description of the correspondence source. E.g., email, text, phone, letter, news article, etc */
  public ReceivedThrough = '';

  /** The people sending/signing this correspondence. */
  @mappable('RequestorCorrespondenceViewModel')
  public RequestorCorrespondences: RequestorCorrespondenceViewModel[] = [];

  /** Requestor free type field */
  public RequestorName = '';

  /** Requestor address, other details free type field. */
  public RequestorDetail = '';

  /** When the University received the correspondence. */
  public DateReceived: Date = null;

  /** When a reply is due, if ever. */
  public DueDate: Date = null;

  /** Status of the correspondence. */
  public Status = '';

  /** Intake and misc notes */
  public Notes = '';

  public Priority = '';

  public CorrespondenceCategories: CorrespondenceCategoryViewModel[] = null;

  public get PrimaryRequestor(): RequestorViewModel {
    const p = (this.RequestorCorrespondences || []).filter(rc => rc.IsPrimary);
    if (p.length >= 1) {
      return p[0].Requestor;
    }
    if ((this.RequestorCorrespondences || []).length) {
      return this.RequestorCorrespondences[0].Requestor;
    }
    return null;
  }

  public get RequestorSummary(): string {
    return (this.RequestorCorrespondences || [])
      .map(rc => (rc.Requestor && rc.Requestor.LastName) || '')
      .join(', ');
  }
}

export const Statuses: string[] = [
  'Intake',
  'Assigned',
  'Completed',
  'Pending AVP',
];
